import {
  DoorStickerTemplate,
  FlyerTemplate,
  HELLOPRINT_SERVICE_LEVELS,
  PolygraphyProductType,
  StickerTemplate,
} from '../../../../../../../services/exports/Constants';
import { ProductOrderingSteps } from '../../../../../../../views/marketing/polygraphy/orders';

export default {
  title: 'Pedir productos impresos',
  steps: {
    [ProductOrderingSteps.ProductInfo]: 'Detalles del producto',
    [ProductOrderingSteps.ShippingInfo]: 'Información de envío',
    payment: 'Pago',
  },
  form: {
    title: 'Detalles del pedido',
    polygraphy_product_id: {
      label: 'Producto',
      placeholder: 'Seleccionar producto',
      options: {
        [PolygraphyProductType.Flyer]: {
          name: 'Folleto - {{template}}',
          templates: {
            [FlyerTemplate.One]: 'Plantilla n.º 1 🆕',
            [FlyerTemplate.Two]: 'Plantilla n.º 2 🆕',
            [FlyerTemplate.Three]: 'Plantilla n.º 3',
            [FlyerTemplate.Four]: 'Plantilla n.º 4',
          },
        },
        [PolygraphyProductType.Sticker]: {
          name: 'Pegatina - {{template}}',
          templates: {
            [StickerTemplate.One]: 'Plantilla n.º 1 🆕',
          },
        },
        [PolygraphyProductType.DoorSticker]: {
          name: 'Pegatina de puerta - {{template}}',
          templates: {
            [DoorStickerTemplate.One]: 'Plantilla n.º 1 🆕',
            [DoorStickerTemplate.Two]: 'Plantilla n.º 2 🆕',
          },
        },
      },
    },
    quantity: {
      label: 'Cantidad',
      placeholder: 'Introduzca la cantidad',
    },
    service_level: {
      label: 'Nivel de servicio',
      options: {
        [HELLOPRINT_SERVICE_LEVELS.SAVER]: 'Económico',
        [HELLOPRINT_SERVICE_LEVELS.STANDARD]: 'Estándar',
        [HELLOPRINT_SERVICE_LEVELS.EXPRESS]: 'Urgente',
      },
    },
    shipping_company_name: {
      label: 'Empresa',
      placeholder: 'Introduzca el nombre de la empresa',
    },
    shipping_salutation: {
      label: 'Tratamiento',
      options: {
        mr: 'Sr.',
        mrs: 'Sra.',
      },
    },
    shipping_first_name: {
      label: 'Nombre',
      placeholder: 'Introduce el nombre',
    },
    shipping_last_name: {
      label: 'Apellido',
      placeholder: 'Introduce el apellido',
    },
    shipping_country: {
      label: 'País',
      placeholder: 'Seleccionar país',
    },
    shipping_state: {
      label: 'Estado',
      placeholder: 'Seleccionar estado',
    },
    shipping_city: {
      label: 'Ciudad',
      placeholder: 'Introduce la ciudad',
    },
    shipping_address: {
      label: 'Dirección',
      placeholder: 'Introduce la dirección',
    },
    shipping_zip_code: {
      label: 'C.P.',
      placeholder: 'Introduce el código postal',
    },
    shipping_phone_number: {
      label: 'Número de teléfono',
      placeholder: 'Introduce el número de teléfono',
    },
    create_invoice: {
      options: {
        true: 'Cobrar automáticamente - Se cobra de inmediato',
        false: 'Enviar gratis - Es un regalo',
      },
    },
  },
  table: {
    title: 'Pedidos anteriores',
    fields: {
      product: 'Producto',
      quantity: 'Cantidad',
      status: 'Estado',
      service_level: 'Nivel de servicio',
      shipping: 'Envío',
      tracking_url: 'URL de seguimiento',
      created: 'Creado',
      updated: 'Última actualización',
    },
  },
  labels: {
    shipping_company: 'Empresa',
    shipping_salutation: 'Tratamiento',
    shipping_first_name: 'Nombre',
    shipping_last_name: 'Apellido',
    shipping_address: 'Dirección',
    shipping_zip_code: 'Código postal',
    shipping_city: 'Ciudad',
    shipping_phone_number: 'Número de teléfono',
    show_shipping_details: 'Detalles de envío',
    track_order: 'Rastrear pedido',
    pending_from_provider: 'Pendiente del proveedor',
  },
  modals: {
    confirmation: {
      title: 'Confirmar detalles del pedido',
    },
    free_order_confirmation: {
      title: '¿Seguro que quieres enviar {{product}} gratis?',
      description: 'Has elegido no cobrar a tu cliente hoy.\n El producto se enviará sin pago.',
      buttons: {
        confirm: 'Sí, enviar gratis',
      },
    },
  },
  buttons: {
    back_to_templates: 'Volver a plantillas',
    preview: 'Vista previa',
    next: 'Siguiente',
    order: 'Crear pedido',
    confirm: 'Confirmar',
  },
  feedback: {
    shop_url_used: 'El producto incluye la URL de la tienda online (<url>{{url}}</url>). ¿Es intencionado?',
    order_total_price: 'Precio total de los productos seleccionados: <strong>{{amount}} NETO</strong>',
  },
  toasts: {
    failed_to_create_order: 'Error al crear el pedido',
    order_got_created: 'Pedido creado',
    failed_to_load_data: 'Error al cargar los datos',
  },
};
